import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-spinners-css';

const Loader = props => {
  if (!props.isVisible) {
    return null;
  }

  return (
    <div className="tutorium-loader">
      <Grid color="#335CC5" />
    </div>
  );
};

Loader.propTypes = {
  isVisible: PropTypes.bool,
};

export default Loader;
